<script>
	import lookups from "../../../stores/lookupStore";

	import TextInput from "../../../components/TextInput.svelte";
	import Checkbox from "../../../components/Checkbox.svelte";
	import Select from "../../../components/Select.svelte";
	import FormRow from "../../../components/FormRow.svelte";
	import FormColumn from "../../../components/FormColumn.svelte";
	import DatePicker from "../../../components/DatePicker.svelte";

	export let claimant;
	export let disabled = null;
</script>

<FormRow>
	<FormColumn cols="6">
		<TextInput label="First name" required {disabled} bind:value={claimant.firstName} id="s_firstName" />
	</FormColumn>
	<FormColumn cols="6">
		<TextInput label="Last name" required {disabled} bind:value={claimant.surname} id="s_surname" />
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn cols="6">
		<DatePicker
			required
			{disabled}
			id="soe_dateOfBirth"
			label="Date of birth"
			validator={true}
			start={new Date(1921, 0, 1)}
			end={new Date()}
			placeholder="e.g. 01/05/1987"
			bind:formattedSelected={claimant.dateOfBirth}
			openOnClass="calendar-icon"
			on:dateChange
			on:dateSelected />
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn>
		<Select
			label="Capacity"
			required
			{disabled}
			id="cap"
			bind:value={claimant.capacityId}
			optionList={$lookups.someoneElseCapacity}
			textProperty="label"
			valueProperty="value"></Select>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn>
		<Checkbox
			required
			{disabled}
			bind:checked={claimant.authorisedToAct}
			label="I am authorised to act on behalf of the Individual"
			id="auth"></Checkbox>
	</FormColumn>
</FormRow>
